import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import LearnosityProvider from 'legacy/src/utility/LearnosityProvider';

/**
 * Provides learnosity response data for other parts
 */
const OtherPartsProvider = (props) => {
  const { children, otherPartsResultsByItem, ...otherProps } = props;
  const [learnosityData, onLearnosityDataReady] = useState(null);

  return (
    <Fragment>
      {(learnosityData || !otherPartsResultsByItem) &&
        React.cloneElement(children, {
          ...otherProps,
          otherPartsResultsByItemData: learnosityData,
        })}
      {otherPartsResultsByItem && (
        <LearnosityProvider
          containerElement="learnosity_other_parts_report_results"
          apiType="reports"
          initOptions={JSON.parse(otherPartsResultsByItem)}
          dataListener={(data) => onLearnosityDataReady(data)}
        />
      )}
    </Fragment>
  );
};

OtherPartsProvider.propTypes = {
  /**
   * Learnosity signed request with a list of other parts reports
   * */
  otherPartsResultsByItem: PropTypes.string,
};

OtherPartsProvider.defaultProps = {
  otherPartsResultsByItem: null,
};

export default OtherPartsProvider;
